export default __webpack_public_path__ + "static/media/castlogo.edd9a49d.png";